import React, { useEffect, useState } from 'react';
import SettingContainer from '../SettingContainer';
import { useConfig } from '../../../DataStore/ConfigContext';
import ActivityLoader from '../../Common/ActivityLoader';
import Notification from '../../Common/Notification';
import { useTheme } from '../../../DataStore/ThemeContext';

const Subjects = () => {
    const { openSettings } = useTheme();
    const [activeRecord, setActiveRecord] = useState(null);
    const { getSubjects, subjectList } = useConfig();

    useEffect(() => {
        getSubjects();
    }, []);

    const handleNew = () => {
        openSettings("New Subject", "ConfigNewSubject");
    };

    const handleEdit = () => {
        openSettings("Edit Subject", "ConfigEditSubject", activeRecord);
    };

    const handleManage = () => {
        openSettings("Manage Subject", "ConfigManageSubject", activeRecord);
    };

    const handleRefresh = () => {
        setActiveRecord(null);
        getSubjects(true);
    };

    const menu = () => (
        <>
            <button type="button" tabIndex="0" className="dropdown-item" onClick={handleNew}>
                <i className="dropdown-icon fa fa-plus-circle"></i>
                <span>New Subject</span>
            </button>
            <button type="button" tabIndex="0" className="dropdown-item" disabled={!activeRecord} onClick={handleEdit}>
                <i className="dropdown-icon fa fa-edit text-primary"></i>
                <span>Edit Selection</span>
            </button>
             <button type="button" tabIndex="0" className="dropdown-item" disabled={!activeRecord} onClick={handleManage}>
                <i className="dropdown-icon fa fa-wrench text-primary"></i>
                <span>Manage Subject</span>
            </button>
            <button type="button" tabIndex="0" className="dropdown-item" onClick={handleRefresh}>
                <i className="dropdown-icon fa fa-sync text-primary"></i>
                <span>Refresh</span>
            </button>
        </>
    );

    return (
        <SettingContainer title="Subjects" icon="fa fa-book" Menu={menu}>
            <div className="table-responsive">
                <table className="align-middle ml-0 mb-3 table table-borderless table-striped table-hover">
                    <thead>
                        <tr>
                            <th className="text-left">Subject</th>
                            <th className="text-left">Level</th>
                            <th className="text-left">Category</th>
                            <th className="text-left">Type</th>
                            <th className="text-left">Must Pass</th>
                            <th className="text-left">Abbreviation</th>
                            <th className="text-left">Timetable Code</th>
                        </tr>
                    </thead>
                    <tbody>
                        {Array.isArray(subjectList) && subjectList.map((item) => (
                            <tr
                                key={item.subject_id}
                                onClick={() => setActiveRecord(item)}
                                className={`${item.subject_id === activeRecord?.subject_id ? 'row-active' : ''}`}
                            >
                                <td className="text-left">{item.subject}</td>
                                <td className="text-left">{item.level?.level || '-'}</td>
                                <td className="text-left">{item.category?.category || '-'}</td>
                                <td className="text-left">{item.type?.type_name || '-'}</td>
                                <td className="text-left">
                                    {item.must_pass === "1" ? (
                                        <span className="badge badge-success">Yes</span>
                                    ) : (
                                        <span className="badge badge-secondary">No</span>
                                    )}
                                </td>
                                <td className="text-left">{item.abbreviation || '-'}</td>
                                <td className="text-left">{item.time_table_abbreviation || '-'}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>

                {subjectList === '404' && <Notification message="No subjects found" />}
                {!subjectList && <ActivityLoader />}
            </div>
        </SettingContainer>
    );
};

export default Subjects;
